/* RESPONSIBLE TEAM: team-messenger */
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import RouteRegexes from 'embercom/lib/route-regexes';
import type Router from '@ember/routing/router-service';

export default class Messenger extends Controller {
  @service declare router: Router;
  @service declare appService: { app: { canUseStandalone: boolean } };

  get app() {
    return this.appService.app;
  }

  queryParams = [];

  declare model: {
    settings: any;
    identity: any;
  };

  get selectedTab(): string | undefined {
    if (RouteRegexes.newSettings.messenger.sales.test(this.router.currentRouteName)) {
      return 'sales';
    } else if (RouteRegexes.newSettings.messenger.web.test(this.router.currentRouteName)) {
      return 'web';
    } else if (RouteRegexes.newSettings.messenger.mobileSdk.test(this.router.currentRouteName)) {
      return 'mobile-sdk';
    } else if (
      RouteRegexes.newSettings.messenger.conversations.test(this.router.currentRouteName)
    ) {
      return 'conversations';
    } else if (RouteRegexes.newSettings.messenger.install.test(this.router.currentRouteName)) {
      return 'install';
    } else if (RouteRegexes.newSettings.messenger.general.test(this.router.currentRouteName)) {
      return 'general';
    } else if (RouteRegexes.newSettings.messenger.security.test(this.router.currentRouteName)) {
      return 'security';
    } else if (RouteRegexes.newSettings.messenger.nudges.test(this.router.currentRouteName)) {
      return 'nudges';
    } else if (
      RouteRegexes.newSettings.messenger.platformSettings.test(this.router.currentRouteName)
    ) {
      return 'platform-settings';
    } else {
      return undefined;
    }
  }

  @action
  setSelectedTab(tab: string) {
    this.navigateToTabs(tab);
  }

  private navigateToTabs(tab: string) {
    switch (tab) {
      case 'sales':
        this.router.replaceWith('apps.app.settings.channels.messenger.sales');
        break;
      case 'web':
        this.router.replaceWith('apps.app.settings.channels.messenger.web', {
          queryParams: { tab: 'content' },
        });
        break;
      case 'mobile-sdk':
        this.router.replaceWith('apps.app.settings.channels.messenger.mobile-sdk', {
          queryParams: {
            tab: this.app.canUseStandalone ? 'styling' : 'content',
          },
        });
        break;
      case 'conversations':
        this.router.replaceWith('apps.app.settings.channels.messenger.conversations', {
          queryParams: {
            tab: this.app.canUseStandalone ? 'fin' : 'teammates',
            section: 'start-conversation-button',
          },
        });
        break;
      case 'install':
        this.router.replaceWith('apps.app.settings.channels.messenger.install', {
          queryParams: { tab: 'web', section: 'web-messenger-setup' },
        });
        break;
      case 'general':
        this.router.replaceWith('apps.app.settings.channels.messenger.general', {
          queryParams: { section: 'inbound-volume' },
        });
        break;
      case 'security':
        this.router.replaceWith('apps.app.settings.channels.messenger.security', {
          queryParams: { tab: 'web', section: 'messenger-security' },
        });
        break;
      case 'nudges':
        this.router.replaceWith('apps.app.settings.channels.messenger.nudges');
        break;
      case 'platform-settings':
        this.router.replaceWith('apps.app.settings.channels.messenger.platform-settings');
        break;
      default:
        this.router.replaceWith('apps.app.settings.channels.messenger.web', {
          queryParams: { tab: 'content' },
        });
        break;
    }
  }
}
